import * as ACTIONS from '../constants/constant_saga_types';

export function searchTerm(search_term) {
  return { type: ACTIONS.SEARCH_TERM, search_term };
}

export function searchingTerm() {
  return { type: ACTIONS.SEARCHING_TERM };
}

export function doneSearchingTerm(payload) {
  return { type: ACTIONS.DONE_SEARCHING_TERM, payload };
}

export function errorSearchingTerm(error) {
  return { type: ACTIONS.ERROR_SEARCHING_TERM, error };
}

export function forceShowResults(force_show_results) {
  return { type: ACTIONS.FORCE_SHOW_RESULTS, force_show_results };
}